<template>
	<div class="tpl activity-detail-wrap">
		<mt-header :class="{'scroll':headerShow}" title="活动详情" fixed>
			<router-link :to="{name:fromPath.name}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<!--<mt-button class="add-friend-btn"  icon="more" slot="right"></mt-button>-->
		</mt-header>
		<div class="activity-img">
			<img v-if="activityInfo.attach" :src="activityInfo.attach[1]" alt="" />
		</div>
		<div class="activity-intro">
			<p class="activity-title">{{activityInfo.title}}</p>
			<p class="activity-time">
				<span>时间：</span> {{activityInfo.start_time | toDateTime | convertTime("YYYY年MM月DD日 HH:mm")}}-{{activityInfo.end_time | toDateTime | convertTime("HH:mm")}}
			</p>
			<div class="activity-address">
				<span>地点：</span>
				<div>
					<p class="address-simple">{{activityInfo.area}}</p>
					<p class="address-detail">{{activityInfo.detailed_address}}</p>
				</div>
			</div>
			<p class="activity-fee"><span>收费：</span>{{activityInfo.registration_fee}} 元/位</p>
		</div>
		<div class="activity-detail">
			<pre style="white-space: pre-wrap;">{{activityInfo.text}}</pre>
		</div>
		<div class="activity-joins">
			<p class="join-title">已报名人数（{{activityInfo.sign_sum||0}}）人</p>
			<div class="joins-list">
				<ul>
					<li v-if="activityInfo.sign" v-for="item in imgs.slice(0,joinLimit)">
						<div class="item-img">
							<img :src="item.avatar">
						</div>
					</li>
					<li v-if="activityInfo.sign_sum>0">
						<div class="item-img" @click="showMoreJoins(joinLimit)">
							更多
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="activity-btn">
			<button @click="joinActivity">立即报名</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "activity-detail",
		data() {
			return {
				uid: "",
				fromPath: "", //来源路由
				aid: "", //活动id
				headerShow:0,
				activityInfo: "",
				joinLimit: 11,
				imgs: []
			}
		},
		mounted(){
			window.addEventListener('scroll', this.handleScroll)
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "finds");
			this.$store.commit("changeTabBarShow", false);

			this.aid = this.$route.query.id;
			console.log(this.aid)

			this.getActivityInfo();
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => { //参数vm就是当前组件的实例。
				vm.fromPath = from;
				console.log(vm.fromPath)
			})
		},
		computed:{
			
		},
		methods: {
			getActivityInfo() {
				this.$axios({
					url: "Appointment/ActivityDtails",
					method: "post",
					data: {
						aid: this.aid
					}
				}).then(res => {
					console.log(res);
					if(res.data.code == 200) {
						this.activityInfo = res.data.data[0];
						this.imgs = res.data.data[0].sign;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			handleScroll(){
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
//				console.log(scrollTop);
  				if(scrollTop>100){
  					this.headerShow = 1;
  				}else{
  					this.headerShow = 0;
  				}
			},
			joinActivity() {
				this.$router.push({
					name:"join-activity",
					query:{
						aid:this.aid
					}
				})
			},
			showMoreJoins(n) {
				console.log(this.imgs.length);
				if(n >= this.imgs.length) {
					this.$toast({
						message: "没有更多了~",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.joinLimit = this.imgs.length;
				}

			}
		}
	}
</script>

<style scoped>
	.activity-detail-wrap {
		background: #f3f3f3;
	}
	
	>>>.mint-button-icon {
		background: rgba(129, 87, 247, .3);
		border-radius: 50%;
		width: 1.5rem;
		height: 1.5rem;
		line-height: 1.5rem;
		text-align: center;
	}
	
	>>>.mint-button-icon i {
		color: #fff;
	}
	
	.mint-header {
		background-color: rgba(255, 255, 255, 0) !important;
		border-bottom: 0 !important;
		transition: 500ms;
	}
	>>>.mint-header .mint-header-title{
		color: transparent;
	}
	>>>.mint-header.scroll .mint-header-title{
		color: #282828;
	}
	.mint-header.scroll{
		background-color: rgba(255, 255, 255, 1) !important;
		box-shadow: 8px 0 12px #282838;
	}
	.activity-img {
		width: 100%;
		background: #fff;
		color: #282828;
	}
	
	.activity-img img {
		width: 100%;
	}
	
	.activity-intro {
		padding: 0 1rem;
		background: #fff;
	}
	
	.activity-intro .activity-title {
		font-size: 1.2rem;
		line-height: 2rem;
		font-weight: bold;
		color: #282828;
		padding: 0.5rem 0;
	}
	
	.activity-intro .activity-time,
	.activity-intro .activity-fee {
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.5rem;
		padding: 0.5rem 0;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.activity-intro .activity-time span,
	.activity-intro .activity-address span,
	.activity-intro .activity-fee span {
		font-size: 0.9rem;
		font-weight: bold;
		margin-right: 1rem;
	}
	
	.activity-intro .activity-address {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.8rem;
		color: #282828;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.5rem 0;
	}
	
	.activity-intro .activity-address .address-simple {
		font-weight: bold;
		line-height: 1.5rem;
	}
	
	.activity-detail {
		background: #fff;
		padding: 1rem;
		font-size: 0.8rem;
		line-height: 1.5rem;
		color: #282828;
	    margin: 0.5rem 0;
	}
	
	.activity-btn {
		padding: 1rem;
		text-align: center;
	}
	
	.activity-btn button {
		width: 100%;
		height: 2.8rem;
		outline: 0;
		border: 0;
		border-radius: 3rem;
		color: #fff;
		font-size: 0.9rem;
		background: linear-gradient(to right, #9c76fd, #b79ffe);
	}
	
	.activity-joins {
		background: #fff;
		font-weight: bold;
	}
	
	.activity-joins .join-title {
		font-size: 0.8rem;
		color: #282828;
		padding: 0.5rem 0.8rem;
	}
	
	.activity-joins ul {
		display: flex;
		justify-content: flex-start;
		align-items: stretch;
		flex-wrap: wrap;
		padding: 0rem 1rem 0.5rem;
	}
	
	.activity-joins li {
		width: 3.5rem;
		height: 3.5rem;
		overflow: hidden;
		padding: 0.3rem;
	}
	
	.activity-joins li:active {
		opacity: 0.7;
	}
	
	.activity-joins li img {
		width: 100%;
		display: block;
	}
	
	.activity-joins .item-img {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		overflow: hidden;
		background: #875bfb;
		font-size: 0.6rem;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/ActivityDetail.vue